import RootComponent from "@/components/RootComponent";
import { createRootRoute } from "@tanstack/react-router";

/**
 * Root route definition
 *
 * This is the root route of the application. It renders the `RootComponent`
 * as the main layout. Not-found (404) and error handling are provided
 * router-wide via `defaultNotFoundComponent` / `defaultErrorComponent` in
 * router.ts (the shared screens from @mbits/mray-react-common).
 *
 * @property {React.ComponentType} component - The main component rendered for the root route.
 */

export const Route = createRootRoute({
  component: RootComponent,
});
